import { auth } from "@/services/auth/auth-service";
import { Icon } from "@iconify/react";
import { SocialProvider } from "@interfaces/auth";
import { Button } from "@heroui/react";

const SOCIAL_PROVIDERS = [
  {
    id: "google",
    displayName: "Google",
    iconName: "flat-color-icons:google",
    iconSize: 24
  },
  {
    id: "linkedin_oidc",
    displayName: "Linkedin",
    iconName: "skill-icons:linkedin",
    iconSize: 22
  }
]

const isWebsiteMode = window.self !== window.top;

const SocialSignIn = () => {

  const onClick = async (provider: SocialProvider) => {
    await auth.logInWithProvider({ provider }).then(({ data }) => {
      if (data && data.authUrl) {
        if (isWebsiteMode) {
          // Open SSO in popup for iframe/website mode
          window.open(data.authUrl, "SSO_Login", "width=500,height=600");
        } else {
          window.location.href = data.authUrl;
        }
      }
    });
  }

  return (
    <div className="flex flex-col gap-2">
      {SOCIAL_PROVIDERS.map(provider => (
        <Button
          key={provider.id}
          onClick={onClick.bind(this, provider.id as SocialProvider)}
          startContent={<Icon icon={provider.iconName} width={provider.iconSize} />}
          variant="bordered">
          Continue with {provider.displayName}
        </Button>
      ))}
    </div>
  )
}

export default SocialSignIn;